export const fnMaxIndex = (max, current) => current + 1 > max ? max : current + 1;